import React from 'react'

import { PageTitle } from '_metronic/layout/core'
// import KumopackStepper from 'Presentation/Components/KumopackStepper'
import { SkeletonFullWidthWithContent } from 'Presentation/Components/Loading/Skeleton'
import DeliveryItem from './Components/DeliveryItem'

import useViewModel from './ViewModel'
import formatNumberCommas from 'Utils/formatNumberCommas'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import { ClientSideTable } from 'Presentation/Components/Table'

//////////
// View //
//////////

const MarketplaceOrderDetailView: React.FC = () => {
	const { isLoading, data, TABLE_CONFIGS } = useViewModel()

	return (
		<ViewPageTitle code={data.code}>
			{!isLoading ? (
				<React.Fragment>
					<div className="row gy-5">
						<div className="col-12">
							<div className="card border-1px border-kumopack-grey-200">
								<div className="card-body">
									<div className="row gy-5">
										<div className="col-12">
											<div
												className="d-flex flex-row bg-kumopack-grey-100 p-5 border border-kumopack-grey-200"
												style={{ gap: '12px' }}>
												<div>
													<img
														src={data?.buyer?.featurePicturePath}
														alt="Person Profile"
														width={40}
														height={40}
														style={{ borderRadius: '50%' }}
													/>
												</div>

												<div>
													<div className="text-kumopack-grey-900">{data?.buyer?.fullnameEn}</div>
													<div className="text-kumopack-grey-600">
														Buyer Code: {data?.buyer?.code}
													</div>
												</div>
											</div>
										</div>

										<div className="col-12 col-xl-2 fw-bolder">หมายเลขคำสั่งซื้อ</div>
										<div className="col-12 col-xl-10">221205U9472ADK</div>

										<div className="col-12 col-xl-2 fw-bolder">ที่อยู่ในการจัดส่ง</div>
										<div className="col-12 col-xl-10">
											******* 268/11 ต.ปลายบาง อำเภอบางกรวย จังหวัดนนทบุรี 11130
										</div>

										<div className="col-12 col-xl-2 fw-bolder text-kumopack-grey-600">
											ข้อมูลการจัดส่ง
										</div>
										<div className="col-12 col-xl-10">
											{/* begin:: Delivery Information */}
											<div
												className="d-flex flex-column flex-xl-row align-items-xl-center mb-5 mt-2 mt-xl-0"
												style={{ columnGap: '12px', rowGap: '5px' }}>
												<span>Standard Delivery - ส่งธรรมดาในประเทศไทย</span>

												<div
													className="d-flex flex-row align-items-center"
													style={{ columnGap: '12px' }}>
													<span>
														<span className="d-none d-xl-inline-block me-2">| </span>
														Kerry Express
													</span>

													<div
														className="btn btn-sm btn-kumopack-grey-100 text-kumopack-grey-400 px-4 py-1 w-fit-content"
														style={{ borderRadius: '16px' }}>
														#SHP5314246011
													</div>
												</div>
											</div>
											{/* end:: Delivery Information */}

											{/* begin:: Status */}
											<div className="w-100 bg-kumopack-grey-50 p-5 position-relative">
												<div
													className="position-absolute text-kumopack-grey-500"
													style={{ left: isMobileDevice() ? '85%' : '90%' }}>
													ย่อ{' '}
													<img
														src="/media/icons/kumopack/chevron-grey-small.svg"
														alt="Chevoron Small Gery"
													/>
												</div>

												<DeliveryItem
													done={true}
													label="พัสดุถูกจัดส่งสำเร็จแล้ว: กรุงเทพมหานคร, ทุ่งครุ"
													date="15/12/2022 09:33"
												/>
												<DeliveryItem
													done={false}
													label="พัสดุถึงศูนย์คัดแยกสินค้า: กรุงเทพมหานคร, บางกอก"
													date="14/12/2022 21:33"
												/>
												<DeliveryItem
													done={false}
													label="บริษัทขนส่งเข้ารับพัสดุเรียบร้อยแล้ว: สมุทรปราการ, PUP"
													date="14/12/2022 16:33"
												/>
											</div>
											{/* end:: Status */}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="col-12">
							<div className="card border-1px border-kumopack-grey-200">
								<div className="card-header">
									<div className="card-title fw-bolder">รายละเอียดการชำระเงิน</div>
									<div className="card-toolbar">
										<div
											className="btn btn-sm btn-kumopack-grey-100 text-kumopack-grey-700 px-4 py-1 w-fit-content me-2"
											style={{ borderRadius: '16px' }}>
											หมายเลขคำสั่งซื้อ 221205U9472ADK{' '}
											<img src="/media/icons/kumopack/copy-03.svg" alt="Copy Icon" />
										</div>
									</div>
								</div>
								<div className="card-body">
									<div className="card border-1px border-kumopack-grey-200">
										<div className="card-header">
											<div className="card-title fw-bolder">
												All Order
												<div className="ms-2 fw-normal btn btn-sm border-radius-16px px-2 py-1 btn-kumopack-secondary-100 text-kumopack-secondary-700">
													1,247 orders
												</div>
											</div>
										</div>
										<div className="card-body p-0">
											<ClientSideTable
												data={data?.items || []}
												columns={TABLE_CONFIGS}
												items_per_page={9999}
											/>
										</div>
									</div>

									<div className="row py-5 px-5 px-xl-8 gy-5">
										{/* begin:: Table */}
										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5 fw-bolder">ยอดรวมมูลค่าสินค้า</div>
										<div className="col-6 col-xl-2 text-end fs-5 fw-bolder d-flex flex-row align-items-center justify-content-end">
											<span className="ms-2">฿{formatNumberCommas(1000)}</span>
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5 fw-bolder">Seller Voucher</div>
										<div className="col-6 col-xl-2 text-end fs-5 fw-bolder d-flex flex-row align-items-center justify-content-end">
											<span className="ms-2">-฿{formatNumberCommas(40)}</span>
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ค่าธรรมเนียมและค่าบริการ</div>
										<div className="col-6 col-xl-2 text-end fs-5 d-flex flex-row align-items-center justify-content-end">
											<span className="ms-2">-฿{formatNumberCommas(89.25)}</span>
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5 ">ค่าคอมมิชชั่น 5%</div>
										<div className="col-6 col-xl-2 text-end fs-5">
											-฿{formatNumberCommas(51.36)}
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ค่าบริการ 1%</div>
										<div className="col-6 col-xl-2 text-end fs-5">
											-฿{formatNumberCommas(10.28)}
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ค่าธุรกรรมทางการเงิน</div>
										<div className="col-6 col-xl-2 text-end fs-5">
											-฿{formatNumberCommas(27.61)}
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-4 fw-bolder">รายจ่ายอื่นๆ</div>
										<div className="col-6 col-xl-2 text-end fs-4 fw-bolder d-flex flex-row align-items-center justify-content-end">
											<span className="ms-2">-฿{formatNumberCommas(82)}</span>
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ส่วนต่างค่าจัดส่ง</div>
										<div className="col-6 col-xl-2 text-end fs-5">-฿{formatNumberCommas(82)}</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-4">
											<hr />
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ยอดชำระรวมสุทธิ</div>
										<div className="col-6 col-xl-2 text-end fs-3 fw-bold">
											฿{formatNumberCommas(788.75)}
										</div>
										{/* end:: Table */}
									</div>
								</div>
							</div>
						</div>

						<div className="col-12">
							<div className="card border-1px border-kumopack-grey-200">
								<div className="card-header">
									<div className="card-title fw-bolder">การชำระเงินของผู้ซื้อ</div>
								</div>
								<div className="card-body">
									<div className="row py-5 px-5 px-xl-8 gy-5">
										{/* begin:: Table */}
										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5 fw-bolder">ยอดรวมมูลค่าสินค้า</div>
										<div className="col-6 col-xl-2 text-end fs-5 fw-bolder d-flex flex-row align-items-center justify-content-end">
											<span className="ms-2">฿{formatNumberCommas(930)}</span>
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ยอดรวมค่าจัดส่ง</div>
										<div className="col-6 col-xl-2 text-end fs-5">฿{formatNumberCommas(50)}</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">Kumopack Voucher</div>
										<div className="col-6 col-xl-2 text-end fs-5">฿{formatNumberCommas(0)}</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">Seller Voucher</div>
										<div className="col-6 col-xl-2 text-end fs-5">฿{formatNumberCommas(0)}</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ค่าธรรมเนียมอื่นๆ</div>
										<div className="col-6 col-xl-2 text-end fs-5">฿{formatNumberCommas(0)}</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-4">
											<hr />
										</div>

										<div className="d-none d-xl-block col-8" />
										<div className="col-6 col-xl-2 text-end fs-5">ยอดชำระรวมสุทธิ</div>
										<div className="col-6 col-xl-2 text-end fs-3 fw-bold">
											฿{formatNumberCommas(980.0)}
										</div>
										{/* end:: Table */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</React.Fragment>
			) : (
				<React.Fragment>
					<div className="row gy-5">
						<div className="col-12">
							<SkeletonFullWidthWithContent />
						</div>

						<div className="col-12">
							<SkeletonFullWidthWithContent />
						</div>
					</div>
				</React.Fragment>
			)}
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children?: React.ReactNode; code: string }> = ({
	children,
	code,
}) => {
	return (
		<React.Fragment>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Marketplace',
						path: '/marketplace',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Orders',
						path: '/marketplace/orders',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Detail',
						path: '#',
						isActive: false,
						isSeparator: false,
					},
				]}>
				{`${code ?? ''}`}
			</PageTitle>

			{children}
		</React.Fragment>
	)
}

export default MarketplaceOrderDetailView
